import { createApp } from 'vue';
import App from './App.vue';

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */

//import FormCheckbox from '@/components/form/inputs/FormCheckbox.vue';
//import FormChipsArray from '@/components/form/inputs/FormChipsArray.vue';
//import FormDate from '@/components/form/inputs/FormDate.vue';
//import FormNestedArray from '@/components/form/inputs/FormNestedArray.vue';
//import FormSelect from '@/components/form/inputs/FormSelect.vue';
//import FormSelectCustom from '@/components/form/inputs/FormSelectCustom.vue';
//import FormTextInput from '@/components/form/inputs/FormTextInput.vue';
//import FormTextarea from '@/components/form/inputs/FormTextarea.vue';

// ... import the rest


import router from './router';
import store from './store';
import i18n from '@/core/plugins/i18n';

//imports for app initialization
import ApiService from '@/core/services/ApiService';
import { initInlineSvg } from '@/core/plugins/inline-svg';
import { initVeeValidate } from '@/core/plugins/vee-validate';
import VueGoogleMaps from '@fawmi/vue-google-maps';

import 'bootstrap';



const app = createApp(App);

/*
app.component('FormCheckbox', FormCheckbox);
app.component('FormChipsArray', FormChipsArray);
app.component('FormDate', FormDate);
app.component('FormNestedArray', FormNestedArray);
app.component('FormSelect', FormSelect);
app.component('FormSelectCustom', FormSelectCustom);
app.component('FormTextInput', FormTextInput);
app.component('FormTextarea', FormTextarea);
*/

app.use(store);
app.use(router);
app.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyBJEyHYG0IA45cudBU-WzIVIpfejwtDtNs',
		libraries: 'places',
	},
});
ApiService.init(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.mount('#app');
